import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/th.ts
var add = "เพิ่ม";
var remove = "เอาออก";
var removeAll = "เอาออกทั้งหมด";
var incomplete = "ขออภัย ข้อมูลบางช่องที่กรอกไม่ถูกต้อง";
var submit = "ส่ง";
var noFiles = "ยังไม่ได้เลือกไฟล์";
var moveUp = "เลื่อนขึ้น";
var moveDown = "เลื่อนลง";
var isLoading = "กำลังโหลด...";
var loadMore = "โหลดเพิ่มเติม";
var next = "ถัดไป";
var prev = "ก่อนหน้า";
var addAllValues = "เพิ่มค่าทั้งหมด";
var addSelectedValues = "เพิ่มค่าที่เลือก";
var removeAllValues = "ลบค่าทั้งหมด";
var removeSelectedValues = "ลบค่าที่เลือก";
var chooseDate = "เลือกวันที่";
var changeDate = "เปลี่ยนวันที่";
var close = "ปิด";
var open = "เปิด";
var accepted = function({
  name
}) {
  return `กรุณายอมรับ ${name}`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} จะต้องเป็นวันที่หลังจาก ${date(args[0])}`;
  }
  return `${sentence(name)} จะต้องเป็นวันที่ที่ยังไม่มาถึง`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} สามารถเป็นได้แค่ตัวอักษรเท่านั้น`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} สามารถเป็นได้แค่ตัวอักษรและตัวเลขเท่านั้น`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} สามารถเป็นได้แค่ตัวอักษรและเว้นวรรคเท่านั้น`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} ต้องมีตัวอักษรตัวอักษร`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} ต้องมีตัวอักษรหรือตัวเลข`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} ต้องมีตัวอักษรหรือช่องว่าง`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} ต้องมีสัญลักษณ์`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} ต้องมีตัวพิมพ์ใหญ่`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} ต้องมีตัวพิมพ์เล็ก`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} ต้องมีตัวเลข`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} จะต้องเป็นสัญลักษณ์`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} เท่านั้นที่สามารถมีตัวอักษรตัวพิมพ์ใหญ่`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} เท่านั้นที่สามารถมีตัวอักษรตัวพิมพ์เล็ก`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} จะต้องเป็นวันที่ที่มาก่อน ${date(args[0])}`;
  }
  return `${sentence(name)} จะต้องเป็นวันที่ที่ผ่านมาแล้ว`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `ช่องนี้ถูกตั้งค่าอย่างไม่ถูกต้อง และจะไม่สามารถส่งข้อมูลได้`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} จะต้องเป็นค่าระหว่าง ${a} และ ${b}`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} ไม่ตรงกัน`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} ไม่อยู่ในรูปแบบวันที่ที่ถูกต้อง กรุณากรอกตามรูปแบบ ${args[0]}`;
  }
  return "ช่องนี้ถูกตั้งค่าอย่างไม่ถูกต้อง และจะไม่สามารถส่งข้อมูลได้";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} จะต้องเป็นวันที่ระหว่าง ${date(args[0])} และ ${date(args[1])}`;
};
var email = "กรุณากรอกที่อยู่อีเมลทีถูกต้อง";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} จะต้องลงท้ายด้วย ${list(args)}`;
};
var is = function({
  name
}) {
  return `${sentence(name)} ไม่ใช่ค่าที่อนุญาตให้กรอก`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} จะต้องมีความยาวอย่างน้อยหนึ่งตัวอักษร`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} จะต้องมีความยาวไม่เกิน ${max2} ตัวอักษร`;
  }
  if (min2 === max2) {
    return `${sentence(name)} ควรจะเป็น ${max2} ตัวอักษรยาว`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} จะต้องมีความยาว ${min2} ตัวอักษรขึ้นไป`;
  }
  return `${sentence(name)} จะต้องมีความยาวระหว่าง ${min2} และ ${max2} ตัวอักษร`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} ไม่ใช่ค่าที่อนุญาตให้กรอก`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `ไม่สามารถเลือกมากกว่า ${args[0]} ${name} ได้`;
  }
  return `${sentence(name)} จะต้องมีค่าไม่เกิน ${args[0]}`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "ไม่มีประเภทของไฟล์ที่อนุญาต";
  }
  return `${sentence(name)} จะต้องเป็นไฟล์ประเภท ${args[0]} เท่านั้น`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `ไม่สามารถเลือกน้อยกว่า ${args[0]} ${name} ได้`;
  }
  return `${sentence(name)} จะต้องมีค่าอย่างน้อย ${args[0]}`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” ไม่ใช่ค่า ${name} ที่อนุญาตให้กรอก`;
};
var number = function({
  name
}) {
  return `${sentence(name)} จะต้องเป็นตัวเลขเท่านั้น`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" หรือ ")} ต้องการ.`;
};
var required = function({
  name
}) {
  return `กรุณากรอก ${sentence(name)}`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} จะต้องเริ่มต้นด้วย ${list(args)}`;
};
var url = function() {
  return `กรุณาระบุที่อยู่ลิงก์ให้ถูกต้อง`;
};
var invalidDate = "วันที่ที่เลือกไม่ถูกต้อง";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var th_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, th_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=th.mjs.map